import React from "react";
import ThemeToggle from "./ThemeToggle";
import darkLogo from "../../assets/DarkMode.png";
import lightLogo from "../../assets/LightMode.png";

const Header = ({ children }) => {
	return (
		<header className="h-16 px-4 border-b border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 flex items-center justify-between w-full overflow-hidden">
			{/* Left side: Mobile preview or Desktop logo */}
			<div className="flex items-center">
				<div className="lg:hidden">{children}</div>
				<div className="hidden lg:flex items-center">
					<img
						src={darkLogo}
						alt="MyCron Logo"
						className="h-8 sm:h-10 w-auto hidden dark:block"
					/>
					<img
						src={lightLogo}
						alt="MyCron Logo"
						className="h-8 sm:h-10 w-auto block dark:hidden"
					/>
					<span className="ml-2 text-sm text-gray-500 dark:text-gray-400">
						Your AI Calendar Assistant
					</span>
				</div>
			</div>

			{/* Right side controls: Theme toggle left of UserMenu */}
			<div className="flex items-center">
				<div className="absolute top-1/2 -translate-y-1/2 right-[60px] lg:right-[10px]">
					<ThemeToggle />
				</div>
			</div>
		</header>
	);
};

export default Header;
